import { combineReducers } from 'redux';

import sportsBookTabs from './sportsBookTabsReducer';
import sportsBookClickedFilter from './sportsBookClickedFilterReducer';
import sportsBookActiveFilters from './sportsBookActiveFiltersReducer';
import sportsBookPersonalizations from './sportsBookPersonalizationReducer';
import sportsBookHeaderFilters from './sportsBookHeaderFiltersReducer';
import sportsBookParentEvents from './sportsBookParentEventsReducer.js';
import sportsBookEventsCount from './sportsBookEventsCountReducer.js';

export default combineReducers({
  sportsBookTabs,
  sportsBookClickedFilter,
  sportsBookEventsCount,
  sportsBookActiveFilters,
  sportsBookPersonalizations,
  sportsBookHeaderFilters,
  sportsBookParentEvents,
});
